// The ASF surveillance area in south-east Finland. Given as lat/lon
// (60.33, 27.29)–(60.97, 28.42); MapLibre takes lon/lat pairs.
export const ASF_BOUNDS: [[number, number], [number, number]] = [
  [27.29, 60.33],
  [28.42, 60.97],
]

export const BOUNDS_PADDING_PX = 24
